/**
 * What the input router counts as a text field on the page: an element that takes typing and is shown.
 */

const NOT_TYPED = new Set(["button", "checkbox", "color", "file", "hidden", "image", "radio", "range", "reset", "submit"]);

/**
 * Reports whether an event target is a text field that takes typing: a text area, an editable element, or
 * an input of any type but the ones that take no typing (buttons, boxes, pickers and sliders). A field
 * hidden since it took focus, as the login panel's is once it logs in, is not one: the browser moves focus
 * off it at its next rendering, and until then it takes no typing.
 *
 * @param target The target, or null.
 * @returns True for a shown text field.
 */
export function isTextField(target: unknown): boolean {
  if (!(target instanceof HTMLElement)) {
    return false;
  }
  const typed = target instanceof HTMLTextAreaElement || (target instanceof HTMLInputElement && !NOT_TYPED.has(target.type)) || target.isContentEditable;
  return typed && target.getClientRects().length > 0;
}
